module.exports = __webpack_public_path__ + "img/youngManmin.f3788296.jpg";